<template>
  <div v-if="ready" class="payment-header__price">
    <div class="payment-header__price__text">
      {{ $t('amount') }}
    </div>

    <div v-show="!amountIsEdit" class="payment-header__price__amount">
      <span ref="titleAmount">{{ invoiceInitialData.amount | formatMoney }}</span>
      &nbsp;{{ invoiceInitialData.currency }}
      <div v-show="editable" class="payment-header__edit-amount" @click="enableEditAmount">
        <edit-svg />
      </div>

      <payment-info v-if="description" :description="description" />
    </div>

    <edit-amount v-if="amountIsEdit" @edit="disableEditAmount($event)" />
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { mapGetters, mapState } from 'vuex';

import EditAmount from './EditAmount';
import EditSvg from '@/components/svg/Edit';
import PaymentInfo from './PaymentInfo';

export default {
  data() {
    return {
      ready: false,
      amountIsEdit: false,
    };
  },

  created() {
    this.ready = true;
  },

  computed: {
    ...mapState(['invoiceInitialData']),

    description() {
      return this.invoiceInitialData.description;
    },

    editable() {
      return false;
    },
  },

  methods: {
    disableEditAmount() {
      this.amountIsEdit = false;
    },

    enableEditAmount() {
      this.amountIsEdit = true;
    },
  },

  components: {
    EditAmount,
    PaymentInfo,
    EditSvg,
  },
};
</script>
